import { Component, Injector, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CreatePacienteDto, PacienteServiceProxy } from '@shared/service-proxies/service-proxies';
import { VerificarCadastroPacienteComponent } from './components/verificar-cadastro-paciente/verificar-cadastro-paciente.component';
import { AppComponentBase } from '@shared/app-component-base';
import { finalize } from 'rxjs/operators';
import { ForgotPasswordDialogComponent } from 'account/forgot-password/forgot-password-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DataNascimentoFormCadastroPacienteComponent } from './components/data-nascimento-form-cadastro-paciente/data-nascimento-form-cadastro-paciente.component';
import { DadosFormCadastroPacienteComponent } from './components/dados-form-cadastro-paciente/dados-form-cadastro-paciente.component';
import { ResponsavelFormCadastroPacienteComponent } from './components/responsavel-form-cadastro-paciente/responsavel-form-cadastro-paciente.component';
import { AceitaTermosFormCadastroPacienteComponent } from './components/aceita-termos-form-cadastro-paciente/aceita-termos-form-cadastro-paciente.component';
import Swal from 'sweetalert2';


@Component({
  selector: 'form-paciente',
  templateUrl: './form-paciente.component.html',
  styleUrls: ['./form-paciente.component.scss']
})
export class FormPacienteComponent extends AppComponentBase {

  protected porcentagem: number = 0;
  protected step: number = 1;
  protected existeCadastro: boolean = false;

  protected paciente: CreatePacienteDto = new CreatePacienteDto();
  protected responsavel: CreatePacienteDto = new CreatePacienteDto();

  protected maxStep: number = 5;
  protected saving: boolean = false;

  @ViewChild('verificarPacienteForm') verificarPacienteForm: VerificarCadastroPacienteComponent;
  @ViewChild('dataNascimentoForm') dataNascimentoForm: DataNascimentoFormCadastroPacienteComponent;
  @ViewChild('dadosFormCadastroPaciente') dadosFormCadastroPaciente: DadosFormCadastroPacienteComponent;
  @ViewChild('dadosResponsavel') dadosResponsavel: ResponsavelFormCadastroPacienteComponent;
  @ViewChild('termosUso') termosUso: AceitaTermosFormCadastroPacienteComponent;

  constructor(
    injector: Injector,
    private router: Router,
    private readonly _pacienteService: PacienteServiceProxy,
    private readonly _modalService: BsModalService,
  ) { super(injector) }

  protected nextStep(): void {
    if (this.step == 1) {
      this.checkEtapa1();
    } else if (this.step == 2) {
      this.checkEtapa2();
    } else if (this.step == 3) {
      this.checkEtapa3();
    } else if (this.step == 4) {
      this.checkEtapa4();
    } else if (this.step == 5) {
      this.checkEtapa5();
    }

  }

  protected back(): void {

    if (this.step == 1) {
      this.router.navigate(["/account/login"]);
      return;
    }

    if (this.step == 5 && !this.paciente.isDependente) {
      this.step = 3;
      this.calcularPorcentagem();
      return;
    }

    this.step -= 1;
    this.calcularPorcentagem();
  }

  protected recuperarSenha(): void {
    this._modalService.show(ForgotPasswordDialogComponent,
      {
        class: 'modal-md',
      });
  }

  private checkEtapa1(): void {

    if (!this.verificarPacienteForm.isValided()) return;

    const { ehEstrangeiro, cpfOrPassaporte } = this.verificarPacienteForm.getDados();
    this.paciente.ehEstrangeiro = ehEstrangeiro;

    abp.ui.setBusy();
    this._pacienteService.existeCadastro(cpfOrPassaporte).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.existeCadastro = result;
      if (!result) {
        if (ehEstrangeiro) this.paciente.numeroPassaporte = cpfOrPassaporte;
        else this.paciente.cpf = cpfOrPassaporte;

        this.step = 2;
        this.calcularPorcentagem();
      }
    });
  }

  private checkEtapa2(): void {
    if (!this.dataNascimentoForm.isValided()) return;

    this.paciente.dataNascimento = this.dataNascimentoForm.getData();
    this.dadosFormCadastroPaciente.updateData();

    if (!this.dataNascimentoForm.ehMaiorIdade()) {
      this.paciente.isDependente = true;
    } else {
      this.paciente.isDependente = false;
    }

    this.step = 3;
    this.calcularPorcentagem();
  }

  private checkEtapa3(): void {
    if (!this.dadosFormCadastroPaciente.isValided()) return;

    if (this.paciente.isDependente) {
      this.step = 4;
    } else {
      this.step = 5;
    }
    this.calcularPorcentagem();
  }

  private checkEtapa4(): void {
    if (!this.dadosResponsavel.isValided()) return;
    this.step = 5;
    this.calcularPorcentagem();
  }

  private checkEtapa5(): void {
    if (!this.termosUso.isValided()) return;

    this.create();
  }

  private create(): void {
    abp.ui.setBusy();
    this.saving = true;

    if (this.paciente.isDependente) {
      this.paciente.celular = this.paciente.responsavelLegalCelular;
      this.paciente.email = this.paciente.responsavelLegalEmail;
    }

    this._pacienteService
      .create(this.paciente)
      .pipe(
        finalize(() => {
          this.saving = false;
          abp.ui.clearBusy();
        })
      )
      .subscribe((paciente) => {
        Swal.fire({
          title: "Sucesso",
          icon: "success",
          html: "Cadastro realizado com sucesso!",
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          allowOutsideClick: false,
          confirmButtonText: "Ok",
          cancelButtonText: "Não",
        }).then(() => {
          this.router.navigate(["account", "login"]);
        });
      });
  }

  private calcularPorcentagem() {
    if (!this.maxStep || this.maxStep <= 0) this.porcentagem = 0;

    const progresso = (this.step / this.maxStep) * 100;
    this.porcentagem = Math.round(progresso);
  }
}
